import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3Icon, GlobeIcon, LayersIcon, SparklesIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { phases, solutionPillars } from '../data/quotation';
const ICONS = [SparklesIcon, LayersIcon, GlobeIcon, BarChart3Icon];
export function ApproachSection() {
  return <section id="approach" className="border-t border-line bg-surface py-20 sm:py-28" data-id="element-10" data-mp="1wz7sftsp3k4s">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-11" data-mp="2knhix90usw29">
        <SectionHeading eyebrow="The approach" title="Snakker is the engagement layer on top of the content you already own" description="We do not replace your website or your medical content. We make it consumable, deploy it consistently across markets, and measure what happens. We start with the corporate brands where digital impact matters most, then scale from there." data-id="element-12" data-mp="2pm2cipllohhq" />

        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-13" data-mp="38d23txgki3e6">
          {solutionPillars.map((pillar, index) => {
          const Icon = ICONS[index % ICONS.length];
          return <motion.article key={pillar.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.06
          }} className="rounded-2xl border border-line bg-white p-7 transition-colors hover:border-primary" data-id="element-14" data-mp="z29gxr77k3qu" data-mpi={index}>
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary" data-id="element-15" data-mp="1hr6afsus6s80">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-16" data-mp="1vp4pz1ku8up3" />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold text-ink-900" data-id="element-17" data-mp="1rqnjmk98ro8q">
                  {pillar.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-500" data-id="element-18" data-mp="3thqsp53hgur6">
                  {pillar.body}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-16" data-id="element-19" data-mp="21ffp6ittfta1">
          <h3 className="font-display text-xl font-semibold tracking-tight text-ink-900" data-id="element-20" data-mp="21gqwgsmgzj5w">
            A phased rollout
          </h3>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink-500" data-id="element-21" data-mp="26gvdqkv7chx6">
            Corporate brands and EU5 first, then more geographies on the same
            master build, then the core brand portfolio planned into the 2027
            budget cycle.
          </p>

          <ol className="mt-6 grid gap-6 md:grid-cols-3" data-id="element-22" data-mp="2kcz2hynb3y29">
            {phases.map(phase => <li key={phase.tag} className={`rounded-2xl border p-7 ${phase.active ? 'border-primary bg-white' : 'border-line bg-white'}`} data-id="element-23" data-mp="2p6l856v1z1ok">
                <span className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider ${phase.active ? 'bg-primary text-white' : 'bg-surface text-ink-500'}`} data-id="element-24" data-mp="334jje3e2uhzu">
                  {phase.tag}
                </span>
                <h4 className="mt-5 font-display text-lg font-semibold text-ink-900" data-id="element-25" data-mp="ij41y2alhj4i">
                  {phase.title}
                </h4>
                <p className="mt-3 text-sm leading-relaxed text-ink-500" data-id="element-26" data-mp="1b66umdslazmu">
                  {phase.body}
                </p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}